<section class="cz-my-zone-help-dialog-component">
  <mat-dialog-title class="mat-dialog-title">
    <div class="row">
      <div class="col-xs-10">
        <h3 class="title">{{'$dashboard_info_title' | translate}}</h3>
      </div>
      <div class="col-xs-2 end-xs">
        <button mat-button mat-dialog-close class="mat-dialog-back-button">
            <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-title>
  <mat-dialog-content>
    <div class="row">
      <div class="col-xs">
        <p>{{'$dashboard_info_content' | translate}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-xs">
        <h5>{{'$dashboard_info_survey_title' | translate}}</h5>
        <p>{{'$dashboard_info_survey_content' | translate}}</p>
      </div>
      <div class="col-xs-4 end-xs button-container">
        <a mat-stroked-button color="accent" href="/my-zone/survey">{{'$dashboard_info_survey_button' | translate}}</a>
      </div>
    </div>
  </mat-dialog-content>
  <mat-actions>
    <div class="row">
      <div class="col-xs-12 end-xs">
        <button mat-flat-button color="accent" mat-dialog-close [innerHTML]="'$btn_close' | translate"></button>
      </div>
    </div>
  </mat-actions>
</section>
